const localeConfig = {
  bra: 'pt-BR',
  usa: 'en-US',
  pry: 'es-PY',
  esp: 'es-ES'
}

// Formata uma quantidade decimal (ex.: vinda de uma coluna decimal(10,3) do
// banco, tipo "40.000" ou "40.500") removendo zeros à direita desnecessários
// e usando o separador decimal do idioma/país atual (ex.: "40" e "40,5" em pt-BR).
export function formatQuantity(value) {
  const number =
    value === null || value === undefined || value === '' ? 0 : parseFloat(value)

  if (isNaN(number)) {
    return ''
  }

  const country = localStorage.getItem('country-code') || 'bra'
  const locale = localeConfig[country] || localeConfig.bra

  return number.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  })
}
